// src/pages/Projects.jsx
import ProjectCard from '../components/ProjectCard';
import NewDynamicBackground from '../components/NewDynamicBackground'; // import background
import { projectsData } from '../data/projectsData';
import './Projects.css';

function Projects() {
  return (
    <>
         <NewDynamicBackground variant={3}/>

      <div className="projects-wrapper">
        {/* Projects list: one card per row */}

          <div className="projects-intro">
          <p>
            Beyond research projects, I have also enjoyed collaborating with designers on exploratory initiatives. While some of these projects led to research outcomes, 
            it has also been especially rewarding to see how each design journey can create an impact that reaches beyond academic publications. 
            These collaborations have allowed me to engage with diverse perspectives, experiment with creative approaches, and transform ideas into meaningful experiences for wider audiences. 
            Along the way, I have been fortunate to work with many inspiring designers, including <a href="https://www.rogierarents.nl/" target="_blank" rel="noopener noreferrer">Studio Rogier Arents, </a>,   
            <a href="https://www.a-plus-n.com/" target="_blank" rel="noopener noreferrer"> A+N Design Studio, </a>  
            <a href="https://jiechen.nl/" target="_blank" rel="noopener noreferrer">Studio JieChe,  </a>,   
            <a href="https://boeyw.com/" target="_blank" rel="noopener noreferrer">Studio Boey </a>.  
          </p>
        </div>


        <div className="projects-list">
          {projectsData.map(project => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </div>
    </>
  );
}

export default Projects;
